import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  loading: false,
  error: '',
}

const getters = {
  usersLoading: state => state.loading,
  usersError: state => state.error,
}

const mutations = {
  [types.SWITCH_FACILITY_REQUEST] (state) {
    state.loading = true
    state.error = ''
  },
  [types.SWITCH_FACILITY_FAILURE] (state, error) {
    state.loading = false
    state.error = error
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}
